import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-800">
      <div className="px-4 md:px-6 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="inline-block mb-4 cursor-pointer">
              <span className="text-2xl font-heading font-bold text-background-50">韩漫漫画</span>
            </Link>
            <p className="text-secondary-200 text-sm leading-relaxed">
              致力于提供最全韩漫大全、优质推荐和流行排行榜。免费下拉式阅读，高清画质，无广告干扰，享受纯粹阅读乐趣。
            </p>
          </div>

          <div>
            <h4 className="text-secondary-300 text-xs font-medium uppercase tracking-wider mb-4">
              订阅更新
            </h4>
            <form
             
              action="http://yashisz.com/"
              method="POST"
              className="flex flex-col gap-3"
            >
              <div className="relative">
                <input
                  type="email"
                  name="email"
                  placeholder="输入您的邮箱"
                  required
                  className="w-full bg-transparent border-b border-secondary-400 text-background-50 text-sm py-2 pr-10 placeholder-secondary-300 focus:outline-none focus:border-background-50 transition-colors"
                />
                <button
                  type="submit"
                  className="absolute right-0 top-1/2 -translate-y-1/2 text-secondary-300 hover:text-background-50 transition-colors cursor-pointer"
                  aria-label="订阅"
                >
                  <i className="ri-arrow-right-line text-lg"></i>
                </button>
              </div>
              <p className="text-secondary-300 text-xs">
                订阅即可获取最新韩漫更新通知
              </p>
              <div className="honeypot-field">
                <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
              </div>
            </form>
          </div>

          <div>
            <h4 className="text-secondary-300 text-xs font-medium uppercase tracking-wider mb-4">
              快速链接
            </h4>
            <ul className="flex flex-col gap-3">
              <li>
                <Link to="/" className="text-background-50/80 hover:text-background-50 text-sm transition-colors cursor-pointer">首页</Link>
              </li>
              <li>
                <Link to="/category" className="text-background-50/80 hover:text-background-50 text-sm transition-colors cursor-pointer">漫画大全</Link>
              </li>
              <li>
                <a href="/#ranking" className="text-background-50/80 hover:text-background-50 text-sm transition-colors cursor-pointer">排行榜</a>
              </li>
              <li>
                <Link to="/about" className="text-background-50/80 hover:text-background-50 text-sm transition-colors cursor-pointer">关于我们</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-secondary-300 text-xs font-medium uppercase tracking-wider mb-4">
              关注我们
            </h4>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-700 text-background-50/80 hover:text-background-50 hover:bg-secondary-600 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-700 text-background-50/80 hover:text-background-50 hover:bg-secondary-600 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-700 text-background-50/80 hover:text-background-50 hover:bg-secondary-600 transition-colors cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-secondary-700 px-4 md:px-6 py-6">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="text-4xl md:text-6xl font-heading font-bold text-secondary-600 tracking-tighter select-none">
            HANMAN
          </div>
          <p className="text-secondary-300 text-xs">
            &copy; {new Date().getFullYear()} 韩漫漫画网站. 版权所有.
          </p>
        </div>
      </div>
    </footer>
  );
}